/** @format */

import { Layout } from "../components/common/Layout";
import NewsRoom from "../components/NewsRoom/NewsRoom";

export default function NewsRoomPage() {
  const meta = {
    title: "In the Press | Qalara",
    description: "",
    keywords: "",
    url: "/newsroom/",
  };

  return (
    <Layout meta={meta}>
      <NewsRoom />
    </Layout>
  );
}
